/**
 * An enum for the different icon types used in a menu item (search, app, grid, see IconTypes.js for other icon types enum)
 */
export default {
	none: 'none',
	onClick: 'onClick',
	menu: 'menu',
	popupContent: 'popupContent',
};
